import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/recommendation-modal.css";
import {
  fetchPiiDetails,
  fetchPiiDetailsAction,
  fetchPiiDetailsTotal,
  fetchPiiDetailsGraph,
} from "../../actions/leakedCredentials";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import moment from "moment";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";


const StolenCredentials = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const auth = useSelector((state) => state?.auth?.user);

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const dispatch = useDispatch();
  const [toggleArray, setToggleArray] = useState({});
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [limit, setLimit] = useState(10);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');


  const state = useSelector(
    (state) => state?.leakedCredential?.piidetails?.data?.data
  );
  const totalItem = useSelector(
    (state) => state?.leakedCredential?.piidetails?.data
  );
  const totalRecords = useSelector(
    (state) => state?.leakedCredential?.piiTotal?.data
  );
  let oldDnsDetails = useSelector(
    (state) => state.leakedCredential?.piiGraph?.data
  );

  let ipArray = [];
  if (oldDnsDetails?.scanDetails) {
    ipArray.push(oldDnsDetails?.scanDetails || 0);
  }

  useEffect(() => {
    fetchPiiDetails(id, dispatch, page, category, search, startDate, endDate, limit);
  }, [id, dispatch, page, category, search, startDate, endDate, limit]);

  useEffect(() => {
    fetchPiiDetailsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchPiiDetailsGraph(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    setTotalItems(totalItem?.totalPersonalInformationLeakage);
  }, [totalItem?.totalPersonalInformationLeakage]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green", // Customize the color as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                leakedPersonalInformationIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchPiiDetailsAction(id, dispatch, page, category, search, data);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      leakedPersonalInformationIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchPiiDetailsAction(id, dispatch, page, category, search, data);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      leakedPersonalInformationIds:
        selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchPiiDetailsAction(id, dispatch, page, category, search, data);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  let mapData = state;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(`${API_URL}/pii-details/${id}/excel`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Personal Information.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const toggleIcon = (_id, index, value) => {
    let val = toggleArray;
    let id = _id + "_" + index;
    if (val[id]) {
      $("#" + _id + "_" + index + "_password").html("******");
      $("#" + _id + "_" + index + "_password_icon").attr("class", "fa fa-eye");
      // fa fa-eye-slash
      delete val[id];
      setToggleArray({ ...val });
    } else {
      $("#" + _id + "_" + index + "_password").html(value);
      $("#" + _id + "_" + index + "_password_icon").attr(
        "class",
        "fa fa-eye-slash"
      );
      val[id] = true;
      setToggleArray({ ...val });
    }
  };

  const reScan = () => {
    let data = {
      "moduleName": ["personalInformation"]
    }
    rescanSingle(id, data)
  }

  const series = [
    totalRecords?.totalPersonalInformationLeakage || 0,
    // totalRecords?.address_count || 0,
    // totalRecords?.ip_address_count || 0,
    // totalRecords?.phone_count || 0,
    // totalRecords?.username_count || 0,
  ];

  const labels = ["Personal Information"];

    // Add these new state variables for date picker
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [tempStartDate, setTempStartDate] = useState(null);
    const [tempEndDate, setTempEndDate] = useState(null);
    const [startDateObj, setStartDateObj] = useState(null);
    const [endDateObj, setEndDateObj] = useState(null);
  
    // Update startDateObj and endDateObj whenever startDate or endDate change
    useEffect(() => {
      if (startDate) {
        setStartDateObj(new Date(startDate));
      }
      if (endDate) {
        setEndDateObj(new Date(endDate));
      }
    }, [startDate, endDate]);
  
    // Update tempStartDate and tempEndDate whenever startDate or endDate change
    useEffect(() => {
      if (startDate) {
        setTempStartDate(new Date(startDate));
      }
      if (endDate) {
        setTempEndDate(new Date(endDate));
      }
    }, [startDate, endDate]);
  
    // Add this new function to format the displayed date range
    const formatDateRange = () => {
      if (startDate && endDate) {
        return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
      } else if (startDate) {
        return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
      } else if (endDate) {
        return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
      }
      return "Select date range"; // Default placeholder text
    };
  
    // Add this function to handle applying the selected date range
    const applyDateRange = () => {
      if (tempStartDate) {
        setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
      } else {
        setStartDate('');
      }
  
      if (tempEndDate) {
        setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
      } else {
        setEndDate('');
      }
  
      setDatePickerOpen(false);
      setPage(1);
    };
  
    // Add this function to clear all dates
    const cancelDateSelection = () => {
      // Clear all date states when cancel is clicked
      setTempStartDate(null);
      setTempEndDate(null);
      setStartDate('');
      setEndDate('');
      setStartDateObj(null);
      setEndDateObj(null);
      setDatePickerOpen(false);
    };
  

  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Personal Information Breached </h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Personal Information
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
           <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
                  <h6 className="mb-3 welcome-textSmall">Records Found</h6>
                  <div className="d-flex mb-4 justify-content-center">
                    {series && series?.length > 0 && <PieChart series={series} label={labels} />}
                  </div>
              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="greenShadow"></span>
                  Address{" "}
                  <span className="float-right">
                    {totalRecords?.address_count}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="yellowShadow"></span>
                  IP Address{" "}
                  <span className="float-right">
                    {totalRecords?.ip_address_count}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="redShadow"></span>
                  Phone Number{" "}
                  <span className="float-right">
                    {totalRecords?.phone_count}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="blueShadow"></span>
                  UserName{" "}
                  <span className="float-right">
                    {totalRecords?.username_count}
                  </span>
                </label>
              </div>

              {/* <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }} onClick={() => setfilterData("multiple")}>
                  Users Breached Multiple Times{" "}
                  <span className="float-right">
                    {breachedPercent?.toFixed(0)}%
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-warning"
                    role="progressbar"
                    aria-valuenow={breachedPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: breachedPercent?.toFixed(0) + "%" }}
                  ></div>
                </div>
              </div> */}

              {/* <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }} onClick={() => setfilterData("contact")}>
                  Contact Number/ address found{" "}
                  <span className="float-right">
                    {phonePasswordPercent?.toFixed(0)}%
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-info"
                    role="progressbar"
                    aria-valuenow={phonePasswordPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: phonePasswordPercent?.toFixed(0) + "%" }}
                  ></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates}
                  ipArray={oldDnsDetails?.scanDetails}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setSelectedIds([]);

              setSearch("");
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row mb-2">
            <div className="col-sm-4">
              <div className="searchBoxInput p-0">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-4 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              {selectedIds.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => Unsnoozed("")}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={selectedIds == 0 ? false : multiCheckTrue}
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th>Date</th>
                  <th>Breached Database</th>
                  <th>Email Address</th>
                  <th>Username</th>
                  <th>Contact Number</th>
                  <th>IP Address</th>
                  <th>Residential Address</th>
                  {category !== "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th style={{ width: "80" }}>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {currentTableData?.map((row, index) => {
                  return (
                    <tr index={"piii_" + index}>
                      {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                        category === "risk-accepted" ||
                        category === "false-positive") && (
                          <td>
                            <input
                              onClick={() => singleClick(row?._id)}
                              checked={selectedIds?.includes(row?._id)}
                              type="checkbox"
                              className="checkUncheck"
                            />
                          </td>
                        )}
                      <td>
                        {" "}
                        {row?.updatedAt
                          ? moment(row?.createdAt).format(
                            "DD-MM-YYYY"
                          )
                          : row?.createdAt
                            ? moment(row?.createdAt).format(
                              "DD-MM-YYYY"
                            )
                            : "NA"}
                      </td>
                      <td style={{ whiteSpace: "unset", width: "100px" }}>
                        <span>
                          {row?.database_name}
                          <br />
                        </span>
                      </td>
                      <td style={{ whiteSpace: "unset", width: "100px" }}>
                        {row?.email || "NA"}
                      </td>
                      <td>
                        <span>
                          {row?.username || "NA"}
                          <br />
                        </span>
                      </td>
                      <td>
                        <span>
                          {Array.isArray(row?.phone)
                            ? row?.phone?.[0] || "NA"
                            : row?.phone && row?.phone !== ""
                              ? row?.phone
                              : "NA"}
                          <br />
                        </span>
                      </td>
                      <td>
                        <span>
                          {row?.ip_address || "NA"}
                          <br />
                        </span>
                      </td>
                      <td>
                        {/* {row?.address || "NA"} */}
                        {typeof row?.address === "object"
                          ? row?.address?.home?.[0] || "NA"
                          : row?.address && row?.address !== ""
                            ? row?.address
                            : "NA"}
                      </td>
                      {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                      {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                        <td>
                          <Box sx={{ width: 160 }}>
                            <FormControl fullWidth>
                              {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedValue}
                                onChange={(event) => {
                                  setAction(event.target.value);
                                  snooze(row?._id, event.target.value);
                                }}
                              >
                                <MenuItem value="pleaseSelect">
                                  Snooze Options
                                </MenuItem>
                                <MenuItem
                                  value="riskAccepted"
                                  onClick={() => {
                                    addModal();
                                    setLookalikeAppId([row._id]);
                                  }}
                                >
                                  Risk Accepted
                                </MenuItem>
                                <MenuItem
                                  value="markAsFalsePositive"
                                  onClick={() => {
                                    addModal();
                                    setLookalikeAppId([row._id]);
                                  }}
                                >
                                  False Positive
                                </MenuItem>
                                <MenuItem value="markAsRemidiated">
                                  Remediated
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </td>
                      )}
                      {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                        category === "false-positive") && (
                          <td>
                            <button
                              className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                              onClick={() => Unsnoozed(row?._id)}
                            >
                              Unsnooze
                            </button>
                          </td>
                        )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItems > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItems}
                  pageSize={limit}
                  onPageChange={(page) => setPage(page)}
                />
              )}
            </div>
            {totalItems > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => { setForValue(e.target.value); setPage(1) }}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified exposure of personal and identity-related information associated
                  with organizational users. This data has been sourced from breached databases, data
                  broker platforms, and public aggregation services. The information is considered
                  <strong> confirmed leaked and accessible</strong>.
                </div>

                <div className="guide-section">
                  <h3>What Is Identity Exposure & PII Leakage</h3>
                  <p>
                    Identity exposure refers to the unauthorized availability of personally identifiable
                    information (PII) such as names, email addresses, phone numbers, usernames, IP history,
                    and residential details. This data is often aggregated from breaches and resold or
                    indexed by data broker platforms.
                  </p>
                </div>

                <div className="guide-section">
                  <h3>Sources Commonly Involved</h3>
                  <ul>
                    <li>Breached consumer and enterprise databases</li>
                    <li>Data broker platforms and people search engines</li>
                    <li>Credential dump and enrichment services</li>
                    <li>Surface web aggregation portals and APIs</li>
                    <li>Dark web resale and profiling forums</li>
                  </ul>
                </div>

                <div className="guide-section">
                  <h3>Why Identity Exposure Is High Risk</h3>
                  <ul>
                    <li>Enables highly targeted phishing and social engineering</li>
                    <li>Increases risk of identity fraud and account takeover</li>
                    <li>Facilitates impersonation of employees and executives</li>
                    <li>Creates long-term privacy and reputational impact</li>
                  </ul>
                </div>

                <div className="guide-section">
                  <h3>Threat Actor Abuse Scenarios</h3>
                  <ul>
                    <li>Spear-phishing using verified personal context</li>
                    <li>SIM-swap and OTP interception attempts</li>
                    <li>Account recovery abuse using personal details</li>
                    <li>Targeting of executives and privileged users</li>
                  </ul>
                </div>

                <div className="guide-section">
                  <h3>Regulatory & Privacy Considerations</h3>
                  <p>
                    Exposure of personal data may trigger obligations under data protection regulations
                    such as ISO 27701, India DPDP Act, GDPR (where applicable), and RBI cyber security
                    expectations. Organizations are expected to demonstrate detection, mitigation, and
                    continuous monitoring of identity risks.
                  </p>
                </div>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Exposure Validation & Classification</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Validate accuracy and freshness of exposed PII</li>
                      <li>Identify data type (email, phone, address, username)</li>
                      <li>Map exposure to affected individuals</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.7 · Privacy Controls</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Risk Mitigation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Notify impacted users where required</li>
                      <li>Strengthen authentication (MFA, recovery controls)</li>
                      <li>Restrict public exposure of personal details</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · RBI IAM</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Fraud & Abuse Monitoring</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Monitor for phishing or impersonation attempts</li>
                      <li>Track anomalous login and recovery activity</li>
                      <li>Flag executive or VIP identity exposure</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.15</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Preventive Controls & Awareness</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Reduce PII footprint across public platforms</li>
                      <li>Educate users on privacy and social engineering</li>
                      <li>Limit third-party data sharing</li>
                    </ul>
                    <div className="compliance-tag">ISO 27701 · Privacy by Design</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring, Documentation & Reporting</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-content">
                    <ul className="checklist-items">
                      <li>Maintain continuous identity monitoring</li>
                      <li>Track recurrence across data broker platforms</li>
                      <li>Document actions for audit and compliance</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.24 · DPDP Act</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default StolenCredentials;
